import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Building2, User, ArrowLeft } from 'lucide-react';
import { logoutUser } from '@/components/utils/logoutUser';

const ChooseProfile = () => {
  const navigate = useNavigate();

  const handleClient = () => {
    navigate('/register-client', { replace: true });
  };

  const handleCompany = () => {
    localStorage.setItem('oauth_context', 'companyRegister');
    navigate('/register-company', { replace: true });
  };

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center px-4 py-8 overflow-hidden">
      {/* Fondo modo claro */}
      <div
        className="absolute inset-0 dark:hidden"
        style={{
          background: `linear-gradient(170deg, #103254 0%, #1a4a6e 40%, #3d7fa0 70%, #e8f4f8 100%)`,
        }}
      />
      {/* Fondo modo oscuro: negro con resplandor teal, igual que Login */}
      <div
        className="absolute inset-0 hidden dark:block"
        style={{
          background: `
            radial-gradient(ellipse at 15% 55%, rgba(40, 142, 127, 0.35) 0%, transparent 55%),
            radial-gradient(ellipse at 85% 15%, rgba(16, 50, 84, 0.45) 0%, transparent 55%),
            linear-gradient(170deg, #050807 0%, #0a1a16 22%, #123a30 42%, #103254 60%, #0a0f14 82%, #000000 100%)
          `,
        }}
      />

      {/* Botón volver */}
      <button
        onClick={async () => {
          await logoutUser();
          navigate('/', { replace: true });
        }}
        className="absolute top-5 left-5 z-10 flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 text-sm text-white hover:bg-white/20 transition-colors"
      >
        <ArrowLeft className="w-4 h-4" />
        <span className="hidden sm:inline font-medium">Volver</span>
      </button>

      {/* Card */}
      <motion.div
        className="relative z-10 bg-white dark:bg-[#1c1c1e] rounded-2xl shadow-2xl p-6 sm:p-8 w-full max-w-sm sm:max-w-md border border-transparent dark:border-white/10"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-xl sm:text-2xl font-semibold text-[#103254] dark:text-white text-center mb-1.5">
          ¿Cómo quieres usar Bookoll?
        </h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 text-center mb-6">
          Elige el tipo de cuenta que mejor te describe
        </p>

        <div className="flex flex-col gap-3">
          {/* Opción Cliente */}
          <motion.button
            onClick={handleClient}
            className="group flex items-center gap-4 p-4 sm:p-5 rounded-xl border-2 border-gray-200 dark:border-white/10 active:border-[#288E7F] active:bg-[#288E7F]/5 dark:active:bg-[#288E7F]/15 hover:border-[#288E7F] hover:bg-[#288E7F]/5 dark:hover:bg-[#288E7F]/15 transition-all duration-200 text-left w-full"
            whileTap={{ scale: 0.98 }}
          >
            <div className="w-11 h-11 rounded-xl bg-[#288E7F]/10 dark:bg-[#288E7F]/20 flex items-center justify-center flex-shrink-0">
              <User className="w-5 h-5 text-[#288E7F]" />
            </div>
            <div>
              <p className="font-semibold text-[#103254] dark:text-white text-base leading-tight">
                Quiero reservar citas
              </p>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5 leading-snug">
                Busca negocios y agenda tus citas fácilmente
              </p>
            </div>
          </motion.button>

          {/* Opción Empresa */}
          <motion.button
            onClick={handleCompany}
            className="group flex items-center gap-4 p-4 sm:p-5 rounded-xl border-2 border-gray-200 dark:border-white/10 active:border-[#103254] active:bg-[#103254]/5 dark:active:bg-white/10 hover:border-[#103254] hover:bg-[#103254]/5 dark:hover:bg-white/10 transition-all duration-200 text-left w-full"
            whileTap={{ scale: 0.98 }}
          >
            <div className="w-11 h-11 rounded-xl bg-[#103254]/10 dark:bg-white/10 flex items-center justify-center flex-shrink-0">
              <Building2 className="w-5 h-5 text-[#103254] dark:text-white" />
            </div>
            <div>
              <p className="font-semibold text-[#103254] dark:text-white text-base leading-tight">
                Ofrezco servicios o tengo un negocio
              </p>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5 leading-snug">
                Autónomo, clínica, salón, estudio… gestiona tu agenda online
              </p>
            </div>
          </motion.button>
        </div>

        <p className="text-xs text-gray-400 dark:text-gray-500 text-center mt-5">
          Puedes crear más perfiles después desde tu cuenta
        </p>
      </motion.div>
    </div>
  );
};

export default ChooseProfile;